<template>
  <div :disabled="!ifTeamleaderAnchorPermission">
    <!-- <br />
    <br /> -->
    <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
    <data-table
      :columns="employeeTableColumns"
      :tableData="employeeData"
      :showinrow="false"
      :search="search"
    >
      <template v-slot:rowcontent="slotprops">
        <img
          class="sm-img"
          v-if="slotprops.value.column.key=='imgSrc'"
          :src="slotprops.value.record[slotprops.value.column.key]"
        />
        <p
          v-if="slotprops.value.column.key!='imgSrc' &&
                                slotprops.value.column.key!='revoke' &&
                                slotprops.value.column.key!='proceed'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
        <div v-if="slotprops.value.column.key=='attachments'">
          <span class="attach-content">
            <img class="atch-img" :src="require('@/assets/File.svg')" />
            <p class="attachment-text" href="#" @click="fnfPayslipsPopup(slotprops.value.record)">FNF Payslip</p>
          </span>
        </div>
        <button
          class="fnfbtn"
          v-if="slotprops.value.column.key=='proceed'"
          @click="proceedToFnf(slotprops.value.record)"
        >Resettle</button>
      </template>
    </data-table>
    <pop-up-window-lg
                v-if="showPopupOtherIncome"
                @back="showPopupOtherIncome = !showPopupOtherIncome"
                header="FNF Payslip"
                >
                  <template v-slot:content>
                    <fnf-payslip-popup
                      @back="showPopupOtherIncome = !showPopupOtherIncome"
                      :FnfPayslipData="fnfPayslipDetails"
                      
                    >
                    </fnf-payslip-popup>
                  </template>
        </pop-up-window-lg>
  </div>
</template>


<script>
import { mapActions, mapGetters, mapState } from "vuex";
import FnfPayslipPopup from "./fnfPayslipPopup.vue"
const crypto = require("crypto");

export default {
  components: {
    FnfPayslipPopup
  },
    data() {
        return {
          showPopupOtherIncome: false,
          fnfPayslipDetails: {},
            designationList: [],
            departmentList: [],
            costCenterList: [],
            locationsList: [],
            bandsList: [],
            gradesList: [],
            department: '',
            designation: '',
            location: '',
            costCenter: '',
            toast:false,
            errmsg:"",
            employeeTableColumns: [
            // {
            // label: "",
            // key: "imgSrc"
            // },
            {
            label: "Code",
            key: "code"
            },
            {
              label: "Name",
              key: "name"
            },
            {
              label: "Email ID",
              key: "email_id"
            },
            {
              label: "Resignation Day",
              key: "initiation_date"
            },
            {
              label: "Last Working Day",
              key: "last_working_date"
            },
            {
              label: "Processed Date",
              key: "processed_date"
            },
            {
              label: "Status",
              key: "fnf_status"
            },
            {
              label: "",
              key: "attachments"
            },
            {
            label: "",
            key: "revoke"
            },{
            label: "",
            key: "proceed"
            }
        ],
        employeeData: [],
        criteriaList: [
          'Cost center',
          'Designation',
          'Location',
          'Department',
          'Band',
          'Grade'
        ],
        paygroupList: [
          'All'
        ],
        valueList: [],
        paygroupSelected: [],
        criteriaSelected: '',
        criteriaValue: [],
        fnfValue: false,
        role: ""
      }
    },
    mounted() {
      this.fetchProcessedFnfList();
      this.fetchPaygroups();
      this.getOrgLeIdList();
    },
    activated() {
        this.getDesignations();
        this.getDepartment();
        this.getCostCenter();
        this.getLocations();
        this.fetchProcessedFnfList();
        this.getOrgLeIdList();
    },
    computed: {
    ...mapState({
      processedFnf: state => state.dashboard.organisation.processfnf.processed,
      paygroupdata: state => state.onboard.paygroup.data
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else {
        return this.getLegalEntityId(0);
      }
    },
    ...mapState("onboard/organization", {
      orgid: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
          if(this.fnfValue) {
            return true;
          } else {
            return false;
          }
        } 
        return false;
        // else {
        //   return true 
        // }
    }
  },
  methods: {
      ...mapActions({
        act_fetchEmpById: "onboard/employees/fetchEmpDataById",
        fetch_businessunits: "onboard/business_units/fetchAll",
        fetch_cost_center: "onboard/cost_centres/fetchAll",
        fetch_designation: "onboard/designations/fetchAll",
        fetch_location: "onboard/locations/fetchAll",
        fetch_bands: "onboard/salary_bands/fetchAll",
        fetch_grades: "onboard/salary_grades/fetchAll",
        act_fetchProcessed: 'dashboard/organisation/processfnf/fetchProcessed',
        act_changeEditMode: 'dashboard/organisation/processfnf/changeEditMode',
        act_download_fnfpayslip: 'dashboard/organisation/processfnf/downloadFnfPayslip',
        act_fetch_paygroups: "onboard/paygroup/fetchAll",
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),
    async fetchValuesList(criteria) {
      try {
        this.valueList = [];
        switch(criteria) {
          case 'Cost center':
                await this.getCostCenter();
                this.valueList = this.costCenterList;
                break;
          case 'Designation':
                await this.getDesignations();
                this.valueList = this.designationList;
                break;
          case 'Location':
                await this.getLocations();
                this.valueList = this.locationsList;
                break;
          case 'Department':
                await this.getDepartment();
                this.valueList = this.departmentList;
                break;
          case 'Band':
                await this.getBands();
                this.valueList = this.bandsList;
                break;
          case 'Grade':
                await this.getGrades();
                this.valueList = this.gradesList;
                break;
          default:
            this.valueList = [];
        }

      } catch (error) {
        //console.log('error', error);
      }
    },
    async fetchProcessedFnfList() {
      try {
        let res = await this.act_fetchProcessed({
          le_id: this.leId
        })
        this.employeeData = [];
        res.data.payload.data.forEach(element => {
          let lastName = element.last_name == null ? '' : element.last_name
          this.employeeData.push({
            code: element.code,
            name: element.first_name == null ? '' : element.first_name +" "+ lastName,
            email_id: element.email_id,
            fnf_status: element.fnf_status,
            initiation_date: element.initiation_date,
            last_working_date: element.last_working_date.split(" ")[0],
            employee_id: element.employee_id,
            le_id: element.le_id,
            fnfID: element.fnfID,
            processed_fnf_flag: 'resettled',
            processed_date: element.processed_date
          });
        });
        this.employeeData.push(await res.data.payload.data.map(emp => {
          return this.act_fetchEmpById(emp.employee_id)
                .then(empData => {
                  return empData.data.payload.emp[0];
            });
        })[0]);
        //console.log(res);
      } catch (error) {
        //console.log('error', error);
      }
    },

    

    async forceDownload(element,) {
      try {
        let url = element;
        const response = await fetch(url);
        const blob = await response.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", "");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      } catch (error) {
        console.error("Error during download:", error);
      }
    },
    
    async fnfPayslipsPopup(item){
      this.fnfPayslipDetails = item;
      this.showPopupOtherIncome = true;
      },
    // async downloadFnfPayslips(empDetails) {
    //   // console.log(empDetails);
    //   try {
    //     let obj = {
    //       legalEntityId: this.leId,
    //       empCode: empDetails.code, // PL_3042
    //     }
    //     let data = await this.encryptData(obj);
    //     // console.log(data, ' ');
    //     let res = await this.act_download_fnfpayslip(data);
    //     let apiResponse = JSON.parse(await this.decrypt(res.data));
    //     if (apiResponse && apiResponse.data && apiResponse.success) {
    //       let test = apiResponse.data.pdfPreSignedUrl;
    //       for (const element of test) {
    //         await this.forceDownload(element);
    //         // window.open(element, '_blank')
    //       }
    //     } else {
    //       this.toast = true;
    //       // console.log(apiResponse, 'api');
    //       this.errmsg = apiResponse.message
    //     }

    //   } catch (error) {
    //     // console.log("this is error log",error);
    //     this.toast = true;
    //     this.errmsg = error;
    //   }
    // },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgid);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.departmentList = res.data.payload.data;
          //console.log('departments list', this.departmentList)
        //   if(this.departmentList.length){
        //     this.departmentList.splice(0, 0, { id: "", name: "All" });
        //   }else{
        //     this.departmentList.push({ id: "", name: "All" });
        //   }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.costCenterList = res.data.payload.data;
          //console.log('cost center list', this.costCenterList)
        //   if(this.costCenterList.length){
        //     this.costCenterList.splice(0, 0, { id: "", name: "All" });
        //   }else{
        //     this.costCenterList.push({ id: "", name: "All" });
        //   }
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          this.bandsList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          this.gradesList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.designationList = res.data.payload.data;
          //console.log('designations', this.designationList)
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async proceedToFnf(record){
      try {
          await this.act_changeEditMode({ editMode: true, record: record });
          this.$router.push({path:`/dashboard/${this.$route.params.entity_index}/organisation/utilities/processfnf`,
          query: { id: record.employee_id }
        })
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchPaygroups() {
      try {
        await this.act_fetch_paygroups(this.leId);
        for (let paygroup of this.paygroupdata[this.leId]) {
          this.paygroupList.push(paygroup.name);
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getLocations() {
        try {
          let res = await this.fetch_location(this.leId);
          this.locationsList = res.data.payload.data;
          //console.log('locations', this.locationsList)
          let dataArr = res.data;
          if (dataArr.length){
            this.locationsData = res.data;
          }

          //console.log("fetchlocations:", res);
        } catch (err) {
          //console.log(err);
        }
      },
    
    async getOrgLeIdList() {
          const org = this.orgid;
          const le = this.leId;
          //console.log("Org:",org);
          //console.log("Le ID",le);
          let bodyParams = {};
          let  data = await this.getOrgLeList({
            data: {
            ...bodyParams
          }});
          this.role = data.data.user.userRole;
          this.fnfValue = data.data.user.permissions.process_fnf;
          //console.log("PL-3406",this.fnfValue);
    }
  }
}
</script>

<style lang="scss" langscoped>
.fnfbtn {
  width: 135px;
  align-self: flex-start;
  background-color: #ffffff;
  border: #34c0be solid 1px;
  color: #34c0be;
  font-weight: bold;
  padding: 10px 10px;
  border-radius: 4px;
}

.attach-content {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #6e6e6e !important;
  cursor: pointer;
  a {
    margin-left: 4px;
    margin-right: 15px;
    font-size: 14px;
    position: relative;
    top: -6px;
  }
}
 
</style>
